function calculateDiscountPercentage(originalPrice, discountedPrice) {
  const discount = originalPrice - discountedPrice;
  const percentage = (discount / originalPrice) * 100;
  return percentage.toFixed(2); 
}

export  {calculateDiscountPercentage}